import archives from "@/api/archives";

export default {
  state: {
    pollingParams: null,
    pollingRunning: false
  },
  mutations: {
    setPollingParams(state, payload) {
      state.pollingParams = payload;
    }
  },
  actions: {
    async workRequest(context) {
      try {
        // 実行中のパラメータがあれば新規にリクエストしない
        let pollingParams = context.state.pollingParams;
        if (pollingParams) {
          return pollingParams;
        }
        pollingParams = {};

        // エクセル作成をリクエストする
        let params = {
          account_id: await context.dispatch("showAccountID"),
          management_id: await context.dispatch("showManagementID"),
          user_id: await context.dispatch("showUserId"),
          with_image: 1,
          type: "paddy_work",
        };
        pollingParams.params = params;
        context.commit("setPollingParams", pollingParams);
        let res = await archives.workRequest(params);

        // タイムアウト時間の設定
        let timeoutSeconds = 5 * 60 * 1000;
        if (res.data && res.data.timeout_seconds) {
          timeoutSeconds = Number(res.data.timeout_seconds) * 1000;
        }
        pollingParams.timeoutSeconds = Date.now() + timeoutSeconds;
        context.commit("setPollingParams", pollingParams);

        return res.data;
      } catch (error) {
        console.log(error);
        return null;
      }
    },
    async workRequestNotPaddy(context) {
      try {
        // 実行中のパラメータがあれば新規にリクエストしない
        let pollingParams = context.state.pollingParams;
        if (pollingParams) {
          return pollingParams;
        }
        pollingParams = {};

        // エクセル作成をリクエストする
        let params = {
          account_id: await context.dispatch("showAccountID"),
          management_id: await context.dispatch("showManagementID"),
          user_id: await context.dispatch("showUserId"),
          with_image: 1,
          type: "global_work",
        };
        pollingParams.params = params;
        context.commit("setPollingParams", pollingParams);
        let res = await archives.workRequest(params);

        // タイムアウト時間の設定
        let timeoutSeconds = 5 * 60 * 1000;
        if (res.data && res.data.timeout_seconds) {
          timeoutSeconds = Number(res.data.timeout_seconds) * 1000;
        }
        pollingParams.timeoutSeconds = Date.now() + timeoutSeconds;
        context.commit("setPollingParams", pollingParams);

        return res.data;
      } catch (error) {
        console.log(error);
        return null;
      }
    },
    async workMonitoring(context) {
      try {
        let params = context.state.pollingParams;
        if (!params) {
          return null;
        }
        let res = await archives.workMonitoring(params.params);
        return res.data;
      } catch (error) {
        console.log(error);
        return null;
      }
    },
    resetPollingParams({commit}) {
      commit("setPollingParams", null);
    }
  },
  getters: {
    getPollingParams(state) {
      return state.pollingParams;
    }
  },
};
